import { ArrowRightOutlined } from '@ant-design/icons';
import { RichiestaPubblicaDto } from '@framework/api-client';
import {
  SubmissionLogic,
  SubmissionStateTag,
} from '@framework/frontoffice-submission';
import { t } from '@framework/i18n';
import { ISODate, TableCellEllipsis } from '@framework/ui';
import { Space } from 'antd';
import { ColumnType, ColumnsType } from 'antd/es/table';
import { ColumnGroupType } from 'antd/lib/table';
import { ApplicantsTableCell } from '../../../submission/ApplicantsTableCell';
export const observationsColumnsBase = {
  oggetto: {
    title: t('observation.oggetto', 'Oggetto'),
    dataIndex: 'oggetto',
    key: 'oggetto',
    sorter: true,
    sortDataIndex: 'oggetto',
    render: (_, record) => (
      <TableCellEllipsis
        tooltip={false}
        expandable={false}
        children={record.richiesta?.oggetto}
      />
    ),
    // ...createColumnFilter(FilterInputType.Text),
  },
  // numeroProcedimento: {
  //   title: t('observation.procedimento', 'Procedimento'),
  //   dataIndex: 'numeroProcedimento',
  //   key: 'numeroProcedimento',
  //   sorter: true,
  //   sortDataIndex: 'numeroProcedimento',
  //   render: (_, record) => record.richiesta?.numeroProcedimento,
  //   // ...createColumnFilter(FilterInputType.Text),
  // },
  // progressivo: {
  //   title: t('observation.numero-istanza', 'Numero Istanza'),
  //   dataIndex: 'progressivo',
  //   key: 'progressivo',
  //   sorter: true,
  //   sortDataIndex: 'progressivo',
  //   render: (_, record) => record.richiesta?.progressivo,
  //   // ...getProgressiveNumberFilter(),
  // },
  datiTitolari: {
    title: t('observation.titolare', 'Titolare'),
    dataIndex: 'datiTitolari',
    key: 'datiTitolari',
    render: (_, record) => {
      const applicants = SubmissionLogic.getApplicant(record.richiesta);
      if (!applicants) return null;
      return <ApplicantsTableCell applicants={applicants} />;
    },
  },
  stato: {
    title: t('observation.stato', 'Stato'),
    dataIndex: 'statoRichiesta',
    key: 'statoRichiesta',
    sorter: true,
    sortDataIndex: 'statoRichiesta',
    render: (_, record) => <SubmissionStateTag submission={record.richiesta} />,
  },
  dataInizioOsservazione: {
    title: t('observation.periodo-osservazione', 'Periodo osservazione'),
    dataIndex: 'dataInizioOsservazione',
    key: 'dataInizioOsservazione',
    width: 160,
    sorter: true,
    sortDataIndex: 'dataInizioOsservazione',
    render: (_, record) => (
      <Space align="center">
        <ISODate date={record.dataInizioOsservazione} />
        <div style={{ fontSize: 10, height: 12 }}>
          <ArrowRightOutlined />
        </div>
        <ISODate date={record.dataFineOsservazione} />
      </Space>
    ),
  },
  osservabile: {
    title: t('observation.osservabile', 'Osservabile'),
    dataIndex: 'osservabile',
    key: 'osservabile',
    render: (_, record) => record.osservabile && 'Sì',
  },

  dataInvio: {
    title: t('observation.data-invio', 'Data invio'),
    dataIndex: 'dataInvio',
    key: 'dataInvio',
    width: 160,
    sorter: true,
    sortDataIndex: 'dataInvio',
    render: (_, record) => <ISODate date={record.richiesta?.dataInvio} />,
  },
} satisfies Record<
  string,
  ColumnGroupType<RichiestaPubblicaDto> | ColumnType<RichiestaPubblicaDto>
>;

export const observationsColumns: ColumnsType<RichiestaPubblicaDto> = [
  // observationsColumnsBase.progressivo,
  observationsColumnsBase.oggetto,
  // observationsColumnsBase.numeroProcedimento,
  observationsColumnsBase.datiTitolari,
  observationsColumnsBase.osservabile,
  observationsColumnsBase.dataInizioOsservazione,
];

export const observationsColumnsMobile: ColumnsType<RichiestaPubblicaDto> = [
  // observationsColumnsBase.progressivo,
  observationsColumnsBase.oggetto,
  // observationsColumnsBase.numeroProcedimento,
  observationsColumnsBase.datiTitolari,
  observationsColumnsBase.osservabile,
];
